import {Component, inject, OnInit, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {SessionService} from "../../../services/session.service";

@Component({
  selector: 'header-component',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: false
})
export class HeaderComponent implements OnInit {
  isLogin: boolean = false;
  private readonly sessionService = inject(SessionService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.sessionService.isLogin
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(res => this.isLogin = res);
  }
}
